<template>
  <section class="dbData" :id="dbName+'Data'" role="tabpanel" :aria-labelledby="dbName+'Tab'" :aria-expanded="[isFirst ? 'true' : 'false']">
    <template>
      <!--情報エリア-->
      <div class="dbData_inner">
        <!--詳細情報-->
        <ul class="g-itemList g-itemList-text" style="margin-top: 25px;">
          <li v-for="(record, index) in records" :key="index" class="g-itemList_el">
            <div class="g-itemList_info">
              <p v-for="(value, name, index) in record.fields" :key="index">
                {{ name }}<span style="margin-left:2px; margin-right:2px;">:</span><span v-html="join(value)"></span>
              </p>
            </div>
          </li>
        </ul>
        <!--/詳細情報-->
      </div>
      <!--/情報エリア-->
    </template>
  </section>
</template>

<script>
export default {
  props: {
    dbName: { type: String, required: true },
    records: { type: Array, required: true },
    isFirst: { type: Boolean, required: true },
  },
  methods: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    }
  }
}
</script>
